var map = {
	"./template-1/agent/agent-winning-claims": "app/styles/client/templates/template-1/agent/agent-winning-claims",
	"./template-10/agent/agent-winning-claims": "app/styles/client/templates/template-10/agent/agent-winning-claims",
	"./template-11/agent/agent-winning-claims": "app/styles/client/templates/template-11/agent/agent-winning-claims",
	"./template-2/agent/agent-winning-claims": "app/styles/client/templates/template-2/agent/agent-winning-claims",
	"./template-3/agent/agent-winning-claims": "app/styles/client/templates/template-3/agent/agent-winning-claims",
	"./template-4/agent/agent-winning-claims": "app/styles/client/templates/template-4/agent/agent-winning-claims",
	"./template-5/agent/agent-winning-claims": "app/styles/client/templates/template-5/agent/agent-winning-claims",
	"./template-6/agent/agent-winning-claims": "app/styles/client/templates/template-6/agent/agent-winning-claims",
	"./template-7/agent/agent-winning-claims": "app/styles/client/templates/template-7/agent/agent-winning-claims",
	"./template-8/agent/agent-winning-claims": "app/styles/client/templates/template-8/agent/agent-winning-claims",
	"./template-9/agent/agent-winning-claims": "app/styles/client/templates/template-9/agent/agent-winning-claims"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3674;